module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decorate"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topBorder"
  }, [_c('span', {
    staticClass: "l mr",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view l"
  }, [_c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484e3616","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/decorate/index.vue
// module id = 140
// module chunks = 1